<script setup>
import PictureLazy from '@maison/components/common/PictureLazy.vue';
import { PhxIcon, slider } from '@phx-styleguides/iwc';
import { onMounted, ref } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  slides: {
    type: Array,
    required: true,
  },
});

const sliderRef = ref(null);
const sliderInstance = ref(null);

onMounted(() => {
  if (sliderRef.value) {
    sliderInstance.value = slider(sliderRef.value, {
      threshold: 5,
      slidesPerView: 'auto',
      mousewheel: {
        forceToAxis: true,
      },
    });
  }
});
</script>

<template>
  <div
    :id="`${id}-slider`"
    ref="sliderRef"
    class="slider slider--collection"
    role="group"
    aria-roledescription="carousel"
    :aria-label="$t('Accessibility.collectionSlider.ariaLabel')"
  >
    <div class="slider__nav slider__nav--prev">
      <button type="button" class="btn btn--icon btn--icon-only btn--sm btn--icon btn--icon-only">
        <span class="btn__icon btn__icon--start">
          <phx-icon icon="triangle-left" class="icon--md" :bidirectional="true" />
        </span>
      </button>
    </div>

    <div class="slider__body" aria-atomic="false" aria-live="polite">
      <div
        v-for="(slide, i) in slides"
        :key="`cluster-slide-${id}-${i}`"
        class="slider__item"
        role="tabpanel"
        :aria-labelledby="`pagination-${i}`"
      >
        <a class="picture picture--actionable" :href="slide.data.href">
          <picture-lazy v-bind="slide.data" />
        </a>
      </div>
    </div>

    <div class="slider__nav slider__nav--next">
      <button type="button" class="btn btn--icon btn--icon-only btn--sm btn--icon btn--icon-only">
        <span class="btn__icon btn__icon--start">
          <phx-icon icon="triangle-right" class="icon--md" :bidirectional="true" />
        </span>
      </button>
    </div>

    <div class="slider__footer">
      <div class="slider__scrollbar"></div>
    </div>
  </div>
</template>
